import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "nav-item dropdown" }
const _hoisted_2 = { style: {"width":"80px"} }
const _hoisted_3 = { class: "text-nowrap" }
const _hoisted_4 = {
  key: 1,
  class: "fa fa-download"
}
const _hoisted_5 = {
  class: "dropdown-menu dropdown-menu-end p-2",
  style: {"min-width":"360px","max-height":"420px","overflow-y":"auto"}
}
const _hoisted_6 = {
  key: 0,
  class: "px-2 py-3 text-center text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_progress_bar = _resolveComponent("b-progress-bar")!
  const _component_b_progress = _resolveComponent("b-progress")!
  const _component_ExportTaskListItem = _resolveComponent("ExportTaskListItem")!
  const _directive_bs_dropdown_fixed = _resolveDirective("bs-dropdown-fixed")!

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("a", {
      href: "#",
      class: "nav-link d-flex align-items-center gap-2",
      "data-bs-toggle": "dropdown",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onToggleClick && _ctx.onToggleClick(...args)), ["prevent"])),
      role: "button",
      "aria-expanded": "false"
    }, [
      (_ctx.activeTask)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_b_progress, {
                max: _ctx.activeTask.progress.of,
                style: {"height":"6px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_progress_bar, {
                    value: _ctx.activeTask.progress.sheet,
                    class: "bg-success"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 8, ["max"])
            ]),
            _createElementVNode("small", _hoisted_3, _toDisplayString(_ctx.activeTask.progress.sheet) + "/" + _toDisplayString(_ctx.activeTask.progress.of), 1)
          ], 64))
        : (_openBlock(), _createElementBlock("i", _hoisted_4))
    ])), [
      [_directive_bs_dropdown_fixed]
    ]),
    _createElementVNode("ul", _hoisted_5, [
      (_ctx.list.length === 0)
        ? (_openBlock(), _createElementBlock("li", _hoisted_6, _toDisplayString(_ctx.helper.trans('export_tasks.empty')), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (task, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: task.id,
          class: _normalizeClass({'border-bottom': index < _ctx.list.length - 1})
        }, [
          _createVNode(_component_ExportTaskListItem, {
            task: task,
            class: "px-2"
          }, null, 8, ["task"])
        ], 2))
      }), 128))
    ])
  ]))
}